import { DateTime } from 'luxon';
import translateMsg from '~/src/lib/translateMsg';

const isToday = (d, format = 'sql') => {
    let date;
    if (format === 'sql') {
        date = DateTime.fromSQL(d);
    }
    if (format === 'iso') {
        date = DateTime.fromISO(d);
    }

    if (DateTime.now().hasSame(date, 'day')) {
        return true;
    }

    return false;
};

const displaydateWithZone = (d, timezone, lang, format = 'sql') => {
    let date;
    if (format === 'sql') {
        date = DateTime.fromSQL(d, { zone: 'UTC' });
    }
    if (format === 'iso') {
        date = DateTime.fromISO(d, { zone: 'UTC' });
    }

    if (DateTime.now().hasSame(date, 'day')) {
        return date
            .setLocale(lang)
            .setZone(timezone)
            .toLocaleString(DateTime.TIME_SIMPLE);
    }

    return `
            ${date.setLocale(lang).setZone(timezone).toFormat('dd LLLL yyyy')}
            
            ${translateMsg('webapp', 'pwa_ui__at')}


            ${date
                .setLocale(lang)
                .setZone(timezone)
                .toLocaleString(DateTime.TIME_SIMPLE)}
            `;
};

const displaydate = (d, business, lang, format = 'sql') => {
    let date;
    if (format === 'sql') {
        date = DateTime.fromSQL(d);
    }
    if (format === 'iso') {
        date = DateTime.fromISO(d);
    }

    if (DateTime.now().hasSame(date, 'day')) {
        return date.setLocale(lang).toLocaleString(DateTime.TIME_SIMPLE);
    }

    return date.setLocale(lang).toLocaleString(DateTime.DATETIME_MED);
};

export { isToday, displaydateWithZone, displaydate };
